import { LayoutHOC } from 'base/ui/layout/layout';
import { createMatchCardCommand } from './matchCardCommand';

export const createMatchCardCommandPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createMatchCardCommand());
};
